var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { Base } from "@studiometa/js-toolkit";
class Accordion extends Base {
  onBtnClick() {
    const containerHeight = this.$options.open ? "0" : "auto";
    const iconText = this.$options.open ? "+" : "\u2013";
    this.$refs.icon.innerHTML = iconText;
    this.$refs.container.style.height = containerHeight;
    this.$options.open = !this.$options.open;
  }
}
__publicField(Accordion, "config", {
  name: "Accordion",
  refs: ["btn", "container", "icon"],
  options: {
    open: { type: Boolean, default: false }
  }
});
export {
  Accordion as default
};


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
